<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-education`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.294 2.402l20.683 9.892a3 3 0 01.524 5.092l-.002 6.176a3 3 0 11-3.5 0V19.13l-17.705 8.469a3 3 0 01-2.588 0L2.023 17.706a3 3 0 010-5.412l20.683-9.892a3 3 0 012.588 0zM11.838 27.184l-.144-.06a2 2 0 00-1.532 3.692l13 6 .175.071a2 2 0 001.46-.053l13-5.654.142-.068a2 2 0 00-1.737-3.6l-12.178 5.297-12.186-5.625zm0 8a2 2 0 10-1.676 3.632l13 6a2 2 0 001.636.018l13-5.654a2 2 0 10-1.596-3.668l-12.178 5.297-12.186-5.625zM5.635 15L24 6.217 42.364 15 24 23.783 5.635 15z"/></svg>
</template>
<script>

export default {
  name: 'IconEducation',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
